import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { TitleSection } from '../../components/title-section/title-section';
import { ProviderService } from '../../services/provider.service';
import { ActivatedRoute } from '@angular/router';
import { IProviderDto } from '../../dto/dashboard';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { IconSvg } from '../../components/icon-svg/icon-svg';
import { DatePipe } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-provider',
  imports: [
    TitleSection,
    IconSvg,
    DatePipe,
    ProgressSpinnerModule,
    AvatarModule,
    ChipModule,
    DividerModule,
    ButtonModule,
  ],
  templateUrl: './provider.html',
  styleUrl: './provider.css',
})
export class Provider implements OnInit {
  private providerService = inject(ProviderService);
  private toastService = inject(ToastService);
  private route = inject(ActivatedRoute);

  provider: WritableSignal<IProviderDto | null> = signal(null);

  isLoading = signal(false);
  isSubmitOnboarding = signal(false);
  isSubmitAppointment = signal(false);
  isAppointmentCompleted = signal(false);

  ngOnInit(): void {
    this.initProviderDetails();
  }

  initProviderDetails(): void {
    this.isLoading.set(true);

    const providerId = this.route.snapshot.paramMap.get('id');
    if (!providerId) return;

    this.providerService.initializeProviderDetails(providerId).subscribe({
      next: (provider) => {
        this.provider.set(provider);
      },
      error: () => {
        this.toastService.error("Erreur lors du chargement des informations du prestataire");
        this.isLoading.set(false);
      },
      complete: () => {
        this.isLoading.set(false);
      }
    });
  }

  getLabelForAvatar(): string {
    const { firstName, lastName } = this.provider()!;
    if (!firstName && !lastName) {
      return 'N/A';
    } else {
      return firstName[0] + lastName[0];
    }
  }

  createStripeConnectAccount(): void {
    this.isSubmitOnboarding.set(true);

    this.providerService.createStripeConnectAccount(this.provider()!.id).subscribe({
      next: (_response) => {
        this.toastService.success("Compte Stripe créé avec succès");
      },
      error: () => {
        this.toastService.error("Une erreur s'est produite lors de la création du compte Stripe");
        this.isSubmitOnboarding.set(false);
      },
      complete: () => {
        this.isSubmitOnboarding.set(false);
      }
    });
  }

  validateAppointment(): void {
    this.isSubmitAppointment.set(true);

    this.providerService.validateAppointment(this.provider()!.id).subscribe({
      next: (response) => {
        if (response.rdvCompletedAt) {
          this.isAppointmentCompleted.set(true);
        }

        this.toastService.success("Rendez-vous validé");
      },
      error: () => {
        this.toastService.error("Une erreur s'est produite lors de la validation du rendez-vous");
        this.isSubmitAppointment.set(false);
      },
      complete: () => {
        this.isSubmitAppointment.set(false);
      }
    });
  }
}
